module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_01_stay-a20dd0a29e5216d033318e10c0f89b95.jpg";